import React, { useRef, useState } from 'react';
import FocusTrap from 'focus-trap-react';
import { DayPicker as ReactDayPicker } from 'react-day-picker';
import { usePopper } from 'react-popper';
import 'react-day-picker/dist/style.css';
import styles from './style.module.scss';

import type { DayPickerSingleProps } from 'react-day-picker/dist';

type Props = DayPickerSingleProps & {
  onValueChange: DayPickerSingleProps['onSelect'];
  placeholder: string;
  value: string;
  disabledDates: any;
};

export default function DayPicker({ onValueChange, placeholder, value, disabledDates }: Props) {
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const popperRef = useRef<HTMLDivElement>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);
  const popper = usePopper(popperRef.current, popperElement, { placement: 'bottom-start' });

  const closePopper = () => setIsPopperOpen(false);

  const handleInputClick = () => setIsPopperOpen(true);

  return (
    <div className={styles.component}>
      <div className={styles['input-container']} ref={popperRef}>
        <input
          type="text"
          placeholder={placeholder}
          readOnly
          value={value}
          onClick={handleInputClick}
        />
      </div>
      {isPopperOpen && (
        <FocusTrap
          active
          focusTrapOptions={{
            initialFocus: false,
            allowOutsideClick: true,
            clickOutsideDeactivates: true,
            onDeactivate: closePopper,
          }}
        >
          <div
            tabIndex={-1}
            style={popper.styles.popper}
            className={styles['dialog-sheet']}
            {...popper.attributes.popper}
            ref={setPopperElement}
            role="dialog"
          >
            <ReactDayPicker
              className={styles['rdp']}
              initialFocus={isPopperOpen}
              mode="single"
              defaultMonth={value ? new Date(value) : new Date()}
              selected={new Date(value) || new Date()}
              onSelect={onValueChange}
              disabled={disabledDates}
            />
          </div>
        </FocusTrap>
      )}
    </div>
  );
}
